import { DataHorariosCallMe } from '../../types/call-me-types';
import { fetchHorariosCallMe } from './fetch/data-fetch';

export const getHorariosCallMeOpenNow = async (): Promise<DataHorariosCallMe | null> => {
	const response = await fetchHorariosCallMe();

	if (response) {
		return response;
	}
	return null;
};
